const prefix = '@followers';

export const FollowersActionType = {
  GetFollowedUsers: `${prefix}/GET_FOLLOWED_USERS`,
  GetUsersFollowing: `${prefix}/GET_USERS_FOLLOWING`,
  GetUsersFollowed: `${prefix}/GET_USERS_FOLLOWED`,
  FollowUser: `${prefix}/FOLLOW_USER`,
  UnfollowUser: `${prefix}/UNFOLLOW_USER`,
};
